// ---------------------------------------------------------------------------
// The drawer's "Workers" field. A crew size is a whole number of people, zero
// or more — the same rule the server's schemas hold (`workerCount`: integer
// ≥ 0). An empty field clears it. Anything else (a negative, a fraction) is not
// a crew size and is refused at the field, so it can never reach the instant
// save (which would be rejected) or the toolbar Save.
// ---------------------------------------------------------------------------

/** The field's value as a crew size, `undefined` for a cleared field, or
 *  `'invalid'` for input that is not a whole number ≥ 0. */
export function parseCrewSize(raw: string): number | undefined | 'invalid' {
  if (raw.trim() === '') return undefined;
  const value = Number(raw);
  return Number.isInteger(value) && value >= 0 ? value : 'invalid';
}
